var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("products")))]),
                      _c(
                        "w-list",
                        [
                          _c(
                            "w-list-item",
                            { attrs: { to: "/settings/products/settings" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "cogs" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("settings"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            { attrs: { to: "/settings/stock" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "cubes" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("stock"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/units",
                                disabled: !_vm.isAdmin,
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "ruler-combined" },
                                  }),
                                ],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("units")) + " "),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            { attrs: { to: "/settings/product-groups" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "object-group" },
                                  }),
                                ],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("product-groups"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            { attrs: { to: "/settings/kramp" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [
                                  _c("w-fa", {
                                    attrs: { prefix: "fab", icon: "box" },
                                  }),
                                ],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("kramp"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/product-taxes",
                                disabled: !_vm.isAdmin || !_vm.hasTaxModule,
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "receipt" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("taxes"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }